import { Component, input, computed } from "@angular/core";
import { ThousandizePipe } from "ev-core";
import { UnitInfo } from "src/models/estate/public-building-info.model";
import { EvGridTableModule, ITableLayoutModel, ITableHeader, BaseListComponent } from "ev-grid-table";
import { DefaultConverterPipe } from "src/app/shared/pipes/defaultconverter.pipe";

@Component({
    selector: "units-table",
    templateUrl: "./units-table.component.html",
    styleUrls: ["./units-table.component.scss"],
    imports: [ThousandizePipe, EvGridTableModule, DefaultConverterPipe],
})
export class UnitsTableComponent extends BaseListComponent<UnitInfo> {
    usageUnits = input<UnitInfo[]>([]);
    maxToShow = input<number>(20);

    originalData = computed(() => this.usageUnits() || []);

    constructor() {
        super();
    }

    protected createHeaders(): ITableHeader[] {
        return [
            {
                name: "Bruksenhetsnummer",
                prop: "functionalUnitNumber",
                desc: false,
                type: "text",
                isSortable: true,
            },
            {
                name: "BruksenhetId",
                prop: "functionalUnitID",
                desc: false,
                type: "number",
                isSortable: true,
            },
            {
                name: "BruksenhetsType",
                prop: "functionalUnitTypeName",
                desc: false,
                type: "text",
                isSortable: true,
            },
            {
                name: "BRA",
                prop: "usableArea",
                desc: false,
                type: "number",
                textAlignment: "right",
                isSortable: true,
            },
            {
                name: "Rom",
                prop: "rooms",
                desc: false,
                type: "number",
                textAlignment: "right",
                isSortable: true,
            },
            {
                name: "Baderom",
                prop: "baths",
                desc: false,
                type: "number",
                textAlignment: "right",
                isSortable: true,
            },
            {
                name: "Kjøkken",
                prop: "kitchenCode",
                desc: false,
                type: "text",
                textAlignment: "right",
                isSortable: true,
            },
            {
                name: "WC",
                prop: "toilets",
                desc: false,
                type: "number",
                textAlignment: "right",
                isSortable: true,
            },
        ];
    }

    protected createDisplayTemplate(): ITableLayoutModel {
        return {
            breakPoints: [
                {
                    gridAreas:
                        '"functionalUnitNumber functionalUnitTypeName" "functionalUnitID functionalUnitID" "usableArea usableArea" "rooms rooms" "baths baths" "kitchenCode kitchenCode" "toilets toilets"',
                    gridColumns: "150px minmax(110px, 1fr)",
                    maxWidth: 550,
                },
                {
                    gridAreas:
                        '"functionalUnitNumber functionalUnitID functionalUnitTypeName usableArea rooms" "baths baths baths baths baths" "kitchenCode kitchenCode kitchenCode kitchenCode kitchenCode" "toilets toilets toilets toilets toilets"',
                    gridColumns: "150px 100px minmax(110px, 1fr) minmax(80px, 1fr) minmax(60px, 1fr)",
                    maxWidth: 767,
                },
                {
                    gridAreas: '"spacingLeft functionalUnitNumber functionalUnitID functionalUnitTypeName usableArea rooms baths kitchenCode toilets"',
                    gridColumns:
                        "50px 150px 100px minmax(110px, 1fr) minmax(80px, 1fr) minmax(60px, 1fr) minmax(80px, 1fr) minmax(60px, 1fr) minmax(60px, 1fr)",
                },
            ],
        };
    }
}
